import React, { useState, useEffect } from 'react';
import { Field, change } from 'redux-form';
import { CommonDropdownOutlined } from '@Components';
import { required } from '@Utils/validation';
import { UserFormContainer } from './style';
import {
  SEND_MONEY_CALCULATOR_SCREEN,
  reasonForTransferMessages,
  STUDENT_ARRAY,
  REMITTANCE_TYPE_CODE
} from '../../utils/constants';
import { IObject } from '../../utils/interface';

interface Ievent {
  key: number;
  value: number;
  text: string;
  code: string;
}

interface ITransferRelatedInformation {
  state: any;
  setState: any;
  getAllformVal: Record<string, any>;
  dispatch: any;
  form: string;
  sourceOfFundsOptions: Array<IObject>;
  reasonForTransferOptions: Array<IObject>;
  studentOptions: Array<IObject>;
}
const TransferRelatedInformation: React.FC<ITransferRelatedInformation> = (props) => {
  const {
    state,
    setState,
    getAllformVal,
    dispatch,
    form,
    sourceOfFundsOptions,
    reasonForTransferOptions,
    studentOptions
  } = props;
  const [reasonForTransferHelperText, setReasonForTransferHelperText] = useState<string>('');

  const handleRemittanceChange = (e: Ievent) => {
    dispatch(change(form, 'remittanceTypeCode', e?.code));
    setState({ ...state, remittanceType: e?.value, remittanceTypeCode: e?.code });
  };

  const handleSourceOfFundsChange = (e: Ievent) => {
    setState({ ...state, sourceOfFunds: e?.value });
  };

  const handleReasonForTransferChange = (e: Ievent) => {
    dispatch(change(form, 'selectedReasonForTransferCode', e?.code));
    setState({ ...state, reasonForTransfer: e?.value });
    if (!STUDENT_ARRAY.includes(e?.code)) {
      dispatch(change(form, 'remittanceType', null));
      dispatch(change(form, 'remittanceTypeCode', null));
    }
  };

  useEffect(() => {
    if (getAllformVal && getAllformVal?.reasonForTransfer) {
      setReasonForTransferHelperText(
        reasonForTransferMessages[getAllformVal?.selectedReasonForTransferCode]
      );
    } else {
      setReasonForTransferHelperText(SEND_MONEY_CALCULATOR_SCREEN?.selectReasonForTransfer);
    }
    // eslint-disable-next-line
  }, [getAllformVal?.reasonForTransfer]);

  return (
    <UserFormContainer>
      <p className="provideInfo">{SEND_MONEY_CALCULATOR_SCREEN.provideTransferInfo}</p>
      <div className="srcFunds customFields">
        <Field
          bindToThisObject={getAllformVal?.sourceOfFunds}
          type="text"
          name="sourceOfFunds"
          placeholder={SEND_MONEY_CALCULATOR_SCREEN.sourceOfFunds}
          validate={[required]}
          component={CommonDropdownOutlined}
          width="100%"
          onDropdownChange={handleSourceOfFundsChange}
          staticValues={sourceOfFundsOptions}
        />
      </div>
      <div className="reasonForTransfer customFields">
        <Field
          bindToThisObject={getAllformVal?.reasonForTransfer}
          type="text"
          name="reasonForTransfer"
          placeholder={SEND_MONEY_CALCULATOR_SCREEN?.reasonForTransfer}
          validate={[required]}
          component={CommonDropdownOutlined}
          width="100%"
          onDropdownChange={handleReasonForTransferChange}
          staticValues={reasonForTransferOptions}
        />
      </div>
      {STUDENT_ARRAY.includes(getAllformVal?.selectedReasonForTransferCode) &&
        getAllformVal?.reasonForTransfer && (
          <>
            <div className="remittanceType customFields">
              <Field
                bindToThisObject={getAllformVal?.remittanceType}
                type="text"
                name="remittanceType"
                placeholder={SEND_MONEY_CALCULATOR_SCREEN?.remittanceType}
                validate={[required]}
                component={CommonDropdownOutlined}
                width="100%"
                onDropdownChange={handleRemittanceChange}
                staticValues={studentOptions}
              />
            </div>
            {getAllformVal?.remittanceTypeCode === REMITTANCE_TYPE_CODE && (
              <p className="reasonForTransferText">
                {SEND_MONEY_CALCULATOR_SCREEN?.payingForSomeOneElseText}
              </p>
            )}
          </>
        )}
      <p className="reasonForTransferText">{reasonForTransferHelperText}</p>
    </UserFormContainer>
  );
};

export default TransferRelatedInformation;
